var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.707 11.293-11-11.00000005c-.3904999-.39038194-1.0235001-.39038194-1.414 0l-11.00000005 11.00000005c-.28590792.2859943-.37142191.7160366-.21667798 1.0896546.15474393.3736179.51928209.6172591.92367798.6173454h1.25000001c.13807119 0 .25.1119288.25.25v9.75c0 .5522848.44771525 1.0000001 1 1.0000001h5.75000003c.13807119 0 .25-.1119289.25-.2500001v-4.75c0-1.3807119 1.11928811-2.5 2.50000001-2.5s2.5 1.1192881 2.5 2.5v4.75c0 .1380712.1119288.2500001.25.2500001h5.75c.5522848 0 1-.4477153 1-1.0000001v-9.75c0-.1380712.1119289-.25.25-.25h1.25c.4043959-.0000863.7689341-.2437275.923678-.6173454.154744-.373618.06923-.8036603-.216678-1.0896546z",
    fill: "#161038",
    fillRule: "evenodd",
    transform: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d5a31caa3fb37f7ac81fd9ce18bac951.svg";
export { ForwardRef as ReactComponent };